export const contactEmail = 'scale@ph2.io'

export const calendlyLink = 'https://calendly.com/scalephase2'
export const googleMapsLink = 'https://goo.gl/maps/uWPSpkB12SH16sfAA'
